import axios from 'axios';
import configService from '@/services/configService';

export default {
  async listConversations({ page, limit }) {
    return axios
      .get(`${configService.get('apiUrl')}/api/chat/conversations`, {
        params: { page, limit }
      })
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async getConversation(id) {
    return axios
      .get(`${configService.get('apiUrl')}/api/chat/conversations/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async deleteConversation(id) {
    return axios
      .delete(`${configService.get('apiUrl')}/api/chat/conversations/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async sendMessage({ conversationId, message }) {
    return axios
      .post(`${configService.get('apiUrl')}/api/chat/message`, {
        conversationId,
        message
      })
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  /**
   * Stream a chat message via SSE using fetch API.
   * Returns the fetch Response object so the caller can read the body stream.
   */
  async streamMessage({ conversationId, message }) {
    const token = localStorage.getItem('auth-key');
    const response = await fetch(
      `${configService.get('apiUrl')}/api/chat/stream`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify({ conversationId, message })
      }
    );

    if (!response.ok) {
      const error = new Error(`Stream request failed with status ${response.status}`);
      error.status = response.status;
      throw error;
    }

    return response;
  }
};
